const apiUrl = process.env.REACT_APP_API_URL;

export async function RenameJavamon(idInstance: number, newName: string) {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/javamon/rename`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ idInstance, newName })
        });
        return await response.ok;
    } catch (error) {
        console.error("Error renaming javamon:", error);
        return false;
    }
}
